// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IMonthlyIncomeSchema {
  /** Валюта **/
  currency?: ECurrency;
  /** Прибыль **/
  income?: number;
}

export enum ECurrency {
  /** € **/
  'Eur' = 'eur',
  /** руб. **/
  'Rur' = 'rur',
  /** $ **/
  'Usd' = 'usd',
}
